/**
 * Curated excerpts from backend/json_data/guidelines.json (nikosu / v36 and v1 samples).
 * Used for mock LLM diff proposals in the accuracy chat sidebar.
 */

export type GuidelinePromptField = 'existence_check_prompt' | 'violation_check_prompt';

export interface GuidelineRuleSnippet {
  guidelineName: string;
  version: number;
  categoryId: string;
  categoryLabel: string;
  ruleId: string;
  ruleName: string;
  field: GuidelinePromptField;
  /** Display lines (prompt split by newline, trimmed). */
  lines: string[];
}

const OVERSEAS_EXISTENCE_LINES = [
  '三菱ＵＦＪカード、三菱ＵＦＪカード ゴールド、三菱ＵＦＪカード・プラチナ・アメリカン・エキスプレス®・カード、ＶＩＡＳＯカード、ＶＩＡＳＯカード（キャラクター券面）の',
  '「海外旅行傷害保険」の記載を探し、記載が存在するか否かを出力してください。ある場合は「True」、ない場合は「False」を出力してください。',
];

const OVERSEAS_VIOLATION_NOTICE_LINES = [
  '### 重要な注意事項：',
  '1. 保険名称の正確性：「海外旅行保険」は違反です。必ず「海外旅行傷害保険」と表記してください。国内も同じく「国内旅行傷害保険」と表記する必要がある',
  '2. 付帯条件の正確性：「利用付帯」「自動付帯」「自動付帯＋利用付帯」を正確に記載してください',
  '4. 補償金額の正確性：各カード毎に定められた正確な金額を記載してください',
  '5. カード毎の保険内容が異なることに注意してください',
];

const INTEREST_EXISTENCE_LINES = [
  'アコムの利率・金利に関する記載の有無を出力してください。',
];

const INTEREST_VIOLATION_LINES = [
  '【注意】アコムに関する記載のみを対象としてください。',
  '貸付利率（実質年率）は「3.0% ～ 18.0%」です。上限が18.0%を超えている場合や、範囲が異なる場合はNGです。',
];

export const GUIDELINE_SNIPPETS: Record<string, { existence?: GuidelineRuleSnippet; violation?: GuidelineRuleSnippet }> = {
  overseas_travel_insurance: {
    existence: {
      guidelineName: 'nikosu',
      version: 1,
      categoryId: 'overseas_travel_insurance',
      categoryLabel: '海外旅行傷害保険',
      ruleId: 'rule_1',
      ruleName: 'rule',
      field: 'existence_check_prompt',
      lines: OVERSEAS_EXISTENCE_LINES,
    },
    violation: {
      guidelineName: 'nikosu',
      version: 1,
      categoryId: 'overseas_travel_insurance',
      categoryLabel: '海外旅行傷害保険',
      ruleId: 'rule_1',
      ruleName: 'rule',
      field: 'violation_check_prompt',
      lines: OVERSEAS_VIOLATION_NOTICE_LINES,
    },
  },
  interest_rate: {
    existence: {
      guidelineName: 'nikosu',
      version: 36,
      categoryId: 'interest_rate',
      categoryLabel: '率、利',
      ruleId: 'rule_1',
      ruleName: '1',
      field: 'existence_check_prompt',
      lines: INTEREST_EXISTENCE_LINES,
    },
    violation: {
      guidelineName: 'nikosu',
      version: 36,
      categoryId: 'interest_rate',
      categoryLabel: '率、利',
      ruleId: 'rule_1',
      ruleName: '1',
      field: 'violation_check_prompt',
      lines: INTEREST_VIOLATION_LINES,
    },
  },
};

export function getSnippetForCategory(
  categoryId: string | null,
  field: GuidelinePromptField
): GuidelineRuleSnippet | undefined {
  if (!categoryId) return undefined;
  return GUIDELINE_SNIPPETS[categoryId]?.[field === 'existence_check_prompt' ? 'existence' : 'violation'];
}
